import { useEffect, useState } from 'react';
import { Heart } from 'lucide-react';
import { useI18n } from '../i18n';
import { api } from '../lib/api';

export default function SocialLinks() {
    const { t } = useI18n();
    const [links, setLinks] = useState([]);

    useEffect(() => {
        api.get('/social-links').then((r) => setLinks(r.data || [])).catch(() => setLinks([]));
    }, []);

    if (!links.length) return null;

    return (
        <section className="mb-8" data-testid="social-links">
            <h2 className="text-[10px] uppercase tracking-widest font-semibold text-brand-ink3 mb-3 inline-flex items-center gap-1">
                <Heart size={11} /> {t('social.header')}
            </h2>
            <div className="grid grid-cols-2 gap-2">
                {links.map((l) => (
                    <a
                        key={l.id}
                        href={l.url}
                        target="_blank"
                        rel="noreferrer"
                        data-testid={`social-${l.id}`}
                        className="flex items-center gap-3 bg-brand-card border border-brand-border rounded-2xl p-3 hover:-translate-y-0.5 hover:border-brand-green/50 transition-all"
                    >
                        <span className="w-9 h-9 rounded-xl flex items-center justify-center text-white text-sm flex-shrink-0" style={{ backgroundColor: l.color }}>
                            <i className={l.icon} aria-hidden="true" />
                        </span>
                        <span className="min-w-0">
                            <span className="block text-[10px] uppercase tracking-widest font-semibold text-brand-ink3">{l.label}</span>
                            <span className="block text-sm text-brand-ink truncate">{l.handle}</span>
                        </span>
                    </a>
                ))}
            </div>
        </section>
    );
}
